/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ApplicablePeriod } from './applicablePeriod';


/**
 * TBC
 */
export interface RdSAPCarbonAmount { 
    /**
     * The carbon value in Tonnes.
     */
    value: number;
    /**
     * A text representation of the carbon value.
     */
    readonly text?: string;
    period?: ApplicablePeriod;
}
export namespace RdSAPCarbonAmount {
}


